exports = module.exports = require("../../../node_modules/css-loader/lib/css-base.js")();
// imports


// module
exports.push([module.id, ".studentSelectorSidebar .studentListSelector{margin-top:20px;margin-bottom:6px}.studentSelectorSidebar .studentListSelector .dropdown-toggle{padding-left:0;text-align:left;white-space:normal}.studentSelectorSidebar .studentSelector{margin-top:10px;margin-bottom:10px}.studentSelectorSidebar .studentSelector .dropdown-toggle{padding-left:0}.studentSelectorSidebar .dropdown-menu{max-width:19rem}.studentSelectorSidebar a.studentRow{display:block;text-decoration:none;margin-bottom:10px;line-height:1.1}.studentSelectorSidebar a.studentRow.selectedStudent{font-weight:700}", ""]);

// exports



//////////////////
// WEBPACK FOOTER
// ./~/css-loader!./~/sass-loader/dist/cjs.js!./assets/sass/data/student_selector_sidebar.scss
// module id = 1314
// module chunks = 0